import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faMinus, faPlus,
  faChevronLeft,
  faEllipsisV, faEllipsisH,
  faPaperPlane,
  faTimes, faTrash, faTrashAlt,
  faAngleRight, faAngleLeft,
  faSpinner, faAsterisk, faSync,
  faCreditCard,
  faPhone, faPhoneSlash
} from '@fortawesome/free-solid-svg-icons'

import {
  faCcVisa, faCcMastercard, faCcDiscover, faCcJcb,
} from '@fortawesome/free-brands-svg-icons'

import { faUserCircle } from '@fortawesome/free-regular-svg-icons'

const icons = {
  faMinus, faPlus,
  faChevronLeft,
  faEllipsisV, faEllipsisH,
  faPaperPlane,
  faTimes, faTrash, faTrashAlt,
  faAngleRight, faAngleLeft,
  faSpinner, faAsterisk, faSync,
  faUserCircle,
  faCreditCard, faCcVisa, faCcMastercard, faCcDiscover, faCcJcb,
  faPhone, faPhoneSlash
}

const FAIcon = (props) => {
  let { icon, ...otherProps } = props
  let iconResource = icons[icon]
  if (!iconResource)
    console.warn("Icon", icon, "is not imported!")

  return (
    <FontAwesomeIcon icon={iconResource} {...otherProps} />
  )
}

export default FAIcon
